import React from 'react'
import useOnConstrain from './use-on-constrain'
import { getMapValue } from '@morningtrain/react-helpers'

export default function useConstraint (name) {
  const [value, setValue] = React.useState(null)

  useOnConstrain((constraints) => {
    const nextValue = getMapValue(constraints, name)

    if (nextValue !== value) {
      setValue(nextValue)
    }
  })

  return value
}
